import { generatePath } from 'react-router-dom';
import classNames from 'classnames';
import { t, jt } from 'ttag';

import { publicMemberProfile } from '@urls';
import { useRegion } from '@hook/useRegion';
import { Alert } from '@ui/Alert';
import { Button } from '@ui/Button';
import { SmartIcon } from '@components/SmartIcon';

import s from './MinOrderPriceSubscriptionBanner.sss';

interface Props {
  className?: string,
  minOrderPrice: number,
  sellerUsername: string,
  isSellerLinkExist?: boolean,
}

export const MinOrderPriceSubscriptionBanner: React.FC<Props> = ({
  className,
  minOrderPrice,
  sellerUsername,
  isSellerLinkExist,
}) => {
  const { currencyName } = useRegion();

  const sellerFeedPath = generatePath(publicMemberProfile, {
    username: sellerUsername,
  });

  const orderMinPriceText = (
    <span
      key="0"
      className={s.bold}
    >
      {t`замовлення від ${minOrderPrice} ${currencyName}`}
    </span>
  );
  const freeDeliveryText = (
    <span
      key="0"
      className={s.bold}
    >
      {t`безкоштовну доставку`}
    </span>
  );

  return (
    (
      <Alert className={classNames(s.root, className)}>
        <SmartIcon
          className={s.icon}
          size="32"
        />
        <p className={s.description}>
          {jt`Оформлюйте ${orderMinPriceText} у одного продавця і отримай ${freeDeliveryText}`}
        </p>
        {isSellerLinkExist && (
        <Button
          className={s.button}
          theme="secondary"
          to={sellerFeedPath}
        >
          {t`Додати інші товари продавця`}
        </Button>
        )}
      </Alert>
    )
  );
};
